import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=484cf79d&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=js&"
export * from "./Icons.vue?vue&type=script&lang=js&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=484cf79d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cf79d",
  null
  
)

export default component.exports